import { render, staticRenderFns } from "./EndingPage.vue?vue&type=template&id=9624e69c&scoped=true"
import script from "./EndingPage.vue?vue&type=script&lang=js"
export * from "./EndingPage.vue?vue&type=script&lang=js"
import style0 from "./EndingPage.vue?vue&type=style&index=0&id=9624e69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9624e69c",
  null
  
)

export default component.exports